import React from "react";
import CryptoJS from "crypto-js";
import AutoForm from "../components/pages/landing-page/ModalForms/AutoForm";
import FlotillasForm from "../components/pages/landing-page/ModalForms/company/FlotillasForm";
import AccidentForm from "../components/pages/landing-page/ModalForms/AccidentForm";
import HogarForm from "../components/pages/landing-page/ModalForms/HogarForm";
import VidaForm from "../components/pages/landing-page/ModalForms/VidaForm";
import TractocamionesForm from "../components/pages/landing-page/ModalForms/company/TractocamionesForm";
import EmpresarialForm from "../components/pages/landing-page/ModalForms/company/EmpresarialForm";

import Logo_Img from "../assets/images/icon/quote_icon.png";
import { Country_Code } from "../constants/index";

const ENCRYPTION_KEY = "*B3R14t3c7*125h7";

export const AES_Encryption = (data) => {
	const iv = new Uint16Array();

	return CryptoJS.AES.encrypt(data, CryptoJS.enc.Utf8.parse(ENCRYPTION_KEY), {
		iv: CryptoJS.enc.Utf8.parse(iv), // parse the IV
		padding: CryptoJS.pad.Pkcs7,
		mode: CryptoJS.mode.CBC,
	}).toString();
};
export const AES_Decryption = (data) => {
	const iv = new Uint16Array();

	return CryptoJS.AES.decrypt(data, CryptoJS.enc.Utf8.parse(ENCRYPTION_KEY), {
		iv: CryptoJS.enc.Utf8.parse(iv), // parse the IV
		padding: CryptoJS.pad.Pkcs7,
		mode: CryptoJS.mode.CBC,
	}).toString(CryptoJS.enc.Utf8);
};

export const TextToPriceFormat = (num) => {
	var text = num.toFixed(2).split(".");
	return (
		"$" +
		text[0]
			.split("")
			.reverse()
			.reduce(function (acc, num, i, orig) {
				return num == "-" ? acc : num + (i && !(i % 3) ? "," : "") + acc;
			}, "") +
		"." +
		text[1]
	);
};

export const SetParameter = (parameters, body) => {
	let str = body;

	for (const param in parameters) {
		str += `&${param}=${parameters[param]}`;
	}
	return str;
};

export const formatISODate = (date) => {
	return date.getFullYear() + "-" + ("0"+(date.getMonth()+1)).slice(-2)  + "-" + ("0" + date.getDate()).slice(-2);
}

export const SetMedicalExpensesJSONParameter = (data, appIdString) => {
	let appId = appIdString.split('=')[1];

	let datos = [];

	datos.push({
		nombre: data.name,
		correo: data.e_mail,
		id_gender: data.id_gender,
		id_cus_parents: 7,
		nacimiento: formatISODate(data.nacimiento),
		telefono: data.phone,
		cp: data.zip_code,
	});

	(data.beneficiario || []).forEach(beneficiary => {
		datos.push({
			nombre: beneficiary.name,
			correo: "",
			id_gender: parseInt(beneficiary.id_gender),
			id_cus_parents: parseInt(beneficiary.id_cus_parents),
			nacimiento: formatISODate(beneficiary.nacimiento),
			telefono: "",
			cp: "",
		});
	});

	let tiposSeguro = {
		"0": "NACIONAL",
		"1": "INTERNACIONAL",
	};

	let formattedData = {
		alias: data.alias,
		tipo_seguro: tiposSeguro[data.tipo_seguro],
		push_token: "",
		APP_ID: appId,
		datos,
	};

	console.log({ formattedData });

	return JSON.stringify(formattedData);
};

export const GetDataFromServer = (url, params, done) => {
	const req = new XMLHttpRequest();

	req.open("POST", url);
	req.onload = () => {
		const response = JSON.parse(AES_Decryption(req.response));
		if (response.status === "success") {
			done(null, response);
		} else {
			done(response);
		}
	};
	req.onerror = () => {
		done(req.response);
	};
	req.send(params);
};
export const ValidatePhone = (num, limit) => {
	let asc = 0;
	let repeated = 0;
	let countryCodeLength = 3;
	let c_code = null;
	if (num.length == 10 && num.match(/^[0-9]+$/) != null) {

		return true
		// const splitted = num.split("").map((a) => parseInt(a));
		// Country_Code.forEach(code => {
		// 	if(code.code){
		// 		if(code.code == (`${splitted[0]}`+`${splitted[1]}`)){
		// 			countryCodeLength = 2;
		// 			c_code = code.name
		// 			return true
		// 		}
		// 		else if(code.code == (`${splitted[0]}`+`${splitted[1]}`+`${splitted[2]}`)){
		// 			console.log('5')
		// 			c_code = code.name
		// 			return ''
		// 		}
		// 	}
		// })

		// if(c_code == null) {
		// 	console.log('3')
		// 	return false;
		// }
		// for (let x = countryCodeLength; x < 10; x++) {
		// 	if(parseInt(splitted[x]) == parseInt(splitted[x+1])){
		// 		repeated++;
		// 	}
		// 	if (
		// 		splitted[x + 1] &&
		// 		Math.abs(parseInt(splitted[x + 1]) - parseInt(splitted[x])) == 1
		// 	) {
		// 		asc++;
		// 	}
		// }
	} 
	else {
		return false
	}
	// else {
	// 	console.log(1)
	// 	return false;
	// }
	// if(repeated > 3){
	// 	console.log(2)
	// 	return false;
	// }

	// console.log(asc)

	// return asc >= 4 ? false : true;
};
export const ShowNavDropdown = () => {
	let elem =
		document.getElementById("basic-navbar-nav")?.firstElementChild
			?.firstElementChild?.lastElementChild;

	return elem.classList.contains("dropdown-menu")
		? elem.classList.add("show")
		: null;
};

export const NumberToString = (x) => {
	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const StringToNumber = (x) => {
	return parseFloat(x.replace(/,/g, ""));
};

export const FindUnique = (left, right, compareFunction) => {
	return left.filter(
		(leftValue) =>
			!right.some((rightValue) => compareFunction(leftValue, rightValue)),
	);
};

export const AllProductsForms = ({ type, title, message, isImage }) => {
	return (
		[
			{
				id: ["flotilla"],
				form: (
					<FlotillasForm
						type={type}
						img={Logo_Img}
						isImage={isImage}
						Heading={title}
					/>
				),
			},
			{
				id: ["empresarial"],
				form: (
					<EmpresarialForm
						type={type}
						img={Logo_Img}
						isImage={isImage}
						Heading={title}
					/>
				),
			},
			{
				id: [
					"accident",
					"company_accident",
					"medical-expense-group",
					"medical-expense",
				],
				form: (
					<AccidentForm
						isImage={isImage}
						message={message}
						img={Logo_Img}
						type={type}
						Heading={title}
					/>
				),
			},
			{
				id: ["automovil"],
				form: (
					<AutoForm
						isImage={isImage}
						message={message}
						img={Logo_Img}
						type={type}
						Heading={title}
					/>
				),
			},
			{
				id: ["hogar"],
				form: (
					<HogarForm
						isImage={isImage}
						type={type}
						img={Logo_Img}
						Heading={title}
					/>
				),
			},
			{
				id: ["tractocamiones"],
				form: (
					<TractocamionesForm
						isImage={isImage}
						img={Logo_Img}
						type={type}
						Heading={title}
					/>
				),
			},
			{
				id: ["vida", "vida-grupo"],
				form: (
					<VidaForm
						isImage={isImage}
						message={message}
						img={Logo_Img}
						type={type}
						Heading={title}
					/>
				),
			},
		].filter((form) => form.id.includes(type))[0]?.form || null
	);
};
